import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatMenu } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  BodyType,
  Category,
  Division,
  HairColor,
  IntimateHair,
  Type,
} from 'interfaces/common';
import { FilterData } from 'interfaces/core';
import {
  BodyTypeService,
  CategoryService,
  DivisionService,
  HairColorService,
  IntimateHairService,
  TypeService,
} from 'services/common';
import { ReloadService } from 'services/core';
import { toTitleCase } from 'helpers';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
})
export class SearchFilterComponent implements OnInit, OnDestroy {
  @ViewChild('menu') private menu!: MatMenu;
  @ViewChild('categoryMenu') private categoryMenu!: MatMenu;
  @ViewChild('typeMenu') private typeMenu!: MatMenu;
  @Output() private submitEmit = new EventEmitter();
  // store data
  public types: Type[] = [];
  public categorys: Category[] = [];
  public searchQuery!: string | null;
  public divisions: Division[] = [];
  public bodyTypes: BodyType[] = [];
  public hairColors: HairColor[] = [];
  public intimateHairs: IntimateHair[] = [];
  // Data Form
  @ViewChild('searchInput') private searchInput!: ElementRef;
  public dataForm!: FormGroup;
  // FilterData

  // TODO: Add a proper type here
  private filter: any = null;
  private isFocused = false;
  private timeOutOngoing?: ReturnType<typeof setTimeout>;
  private timeOutSubmit?: ReturnType<typeof setTimeout>;

  // select location
  public isSelectedValue: any;
  // TODO: Add a proper type here
  public isSelectedValueName?: string;

  // select category
  // TODO: Add a proper type here
  public isSelectedValueCategory: any;

  // select type
  // TODO: Add a proper type here
  public isSelectedValueType: any;

  // Subscriptions
  private subTypeService: Subscription = Subscription.EMPTY;
  private subDivisionData: Subscription = Subscription.EMPTY;
  private subFilterForm: Subscription = Subscription.EMPTY;
  private subHairColor: Subscription = Subscription.EMPTY;
  private subIntimateHair: Subscription = Subscription.EMPTY;
  private subOrientation: Subscription = Subscription.EMPTY;
  private subBodyType: Subscription = Subscription.EMPTY;
  private subRouteOne: Subscription = Subscription.EMPTY;

  //Advanced Filter variables
  public advancedFilter = false;
  private isSubmitDisabled = false;

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private typeService: TypeService,
    private divisionService: DivisionService,
    private reloadService: ReloadService,
    private router: Router,
    private hairColorService: HairColorService,
    private intimateHairService: IntimateHairService,
    private bodyTypeService: BodyTypeService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.subRouteOne = this.activatedRoute.queryParams.subscribe(qParam => {
      if (Object.keys(qParam).length > 0) {
        // Check if searchQuery exists in queryParams
        if (Object.prototype.hasOwnProperty.call(qParam, 'searchQuery')) {
          this.searchQuery = qParam['searchQuery'].trim();
        }
        this.initDataForm(qParam);
      } else {
        this.initDataForm();
      }
      this.getAllCategory();
      this.getAllType();
      this.getAllDivision();
      this.getAllHairColor();
      this.getAllIntimateHair();
      this.getAllBodyType();
    });
  }
  // TODO: Add better type
  private initDataForm(params?: any) {
    this.dataForm = this.fb.group({
      divisions: [null],
      area: [null],
      zone: [null],
      category: [null],
      type: [null],
      height: this.fb.group({
        minHeight: [140],
        maxHeight: [220],
      }),
      weight: this.fb.group({
        minWeight: [40],
        maxWeight: [300],
      }),
      age: this.fb.group({
        minAge: [18],
        maxAge: [80],
      }),
      bodytype: [null],
      hairColor: [null],
      intimateHairs: [null],
      isGoingOut: [false],
      ownPlace: [false],
      acceptsHandicapped: [false],
      verified: [null],
    });

    this.timeOutOngoing = setTimeout(() => {
      if (params && Object.keys(params).length > 0) {
        if (params['bodyTypes']) {
          this.dataForm?.controls['bodytype'].setValue(params['bodyTypes']);
        }
        if (params['hairColors']) {
          this.dataForm?.controls['hairColor'].setValue(params['hairColors']);
        }
        if (params['intimateHairs']) {
          this.dataForm?.controls['intimateHairs'].setValue(
            params['intimateHairs']
          );
        }
        if (params['divisions']) {
          this.onSelectBtnDis(params['divisions'], 'divisions');
        }
        if (params['area']) {
          this.onSelectBtnDis(params['area'], 'area');
        }
        if (params['zone']) {
          this.onSelectBtnDis(params['zone'], 'zone');
        }
        if (params['categories']) {
          this.onSelectBtnCategory(params['categories']);
        }
        if (params['types']) {
          this.onSelectBtnType(params['types']);
        }
        if (params['age']) {
          const minmaxArr = params['age'].split('-');
          this.dataForm?.controls['age'].setValue({
            minAge: minmaxArr[0],
            maxAge: minmaxArr[1],
          });
        }
        if (params['weight']) {
          const minmaxArr = params['weight'].split('-');
          this.dataForm?.controls['weight'].setValue({
            minWeight: Number(minmaxArr[0]),
            maxWeight: Number(minmaxArr[1]),
          });
        }
        if (params['height']) {
          const minmaxArr = params['height'].split('-');
          this.dataForm?.controls['height'].setValue({
            minHeight: Number(minmaxArr[0]),
            maxHeight: Number(minmaxArr[1]),
          });
        }
        if (params['isGoingOut']) {
          this.dataForm?.controls['isGoingOut'].setValue(true);
        }
        if (params['ownPlace']) {
          this.dataForm?.controls['ownPlace'].setValue(true);
        }
        if (params['acceptsHandicapped']) {
          this.dataForm?.controls['acceptsHandicapped'].setValue(true);
        }
        if (params['verified'] && params['verified'] === 'true') {
          this.dataForm?.controls['verified'].setValue(true);
        }
      }
    }, 1000);
  }

  public onSubmit() {
    if (this.isSubmitDisabled) return;
    this.isSubmitDisabled = true;
    const formData = this.dataForm?.value;
    const inputVal = (this.searchInput.nativeElement as HTMLInputElement).value;
    this.submitEmit.emit({ formData, inputVal });
    this.advancedFilter = false;
    this.timeOutSubmit = setTimeout(() => {
      this.isSubmitDisabled = false;
    }, 1000);
  }
  /**
   * HANDLE SEARCH Area
   * onClickHeader()
   * onClickSearchArea()
   * handleFocus()
   * setPanelState()
   * handleOpen()
   * handleOutsideClick()
   * handleCloseOnly()
   */

  public onClickSearchArea(event: MouseEvent): void {
    event.stopPropagation();
  }

  public handleFocus(): void {
    this.searchInput.nativeElement.focus();
    if (this.isFocused) return;
    this.isFocused = true;
    // const target = this.searchInput.nativeElement as HTMLInputElement;
    //target.placeholder = '';
    clearInterval(this.timeOutOngoing);
  }

  public onSearchNavigate() {
    const inputVal = (this.searchInput.nativeElement as HTMLInputElement).value;
    if (inputVal) {
      this.router.navigate(['/', 'ads'], {
        queryParams: { searchQuery: inputVal.trim() },
        queryParamsHandling: '',
      });
      this.reloadService.needRefreshSearch$(true);
    }
  }

  /**
   * HTTP REQ HANDLE
   * getAllType()
   * getAllDivision();
   */

  private getAllType() {
    const filter: FilterData = {
      filter: this.filter,
      pagination: undefined,
      sort: [{ createdAt: 'desc' }],
    };

    this.subTypeService = this.typeService.getAllType(filter).subscribe({
      next: res => {
        if (res.success) {
          this.types = res.data;
        }
      },
      error: err => console.log(err),
    });
  }

  private getAllCategory() {
    const filter: FilterData = {
      sort: [{ createdAt: 'desc' }],
    };

    this.subTypeService = this.categoryService
      .getAllCategory(filter)
      .subscribe({
        next: res => {
          if (res.success) {
            this.categorys = res.data;
          }
        },
        error: err => console.log(err),
      });
  }

  private getAllDivision() {
    const mSelect = {
      name: true,
      id: true,
    };
    const filter: FilterData = {
      filter: undefined,
      select: mSelect,
      pagination: undefined,
      sort: [{ createdAt: 'asc' }],
    };

    this.subDivisionData = this.divisionService
      .getAllDivisionsdd(filter)
      .subscribe(
        res => {
          if (res.success) {
            this.divisions = res.data;
          }
        },
        err => console.log(err)
      );
  }
  private getAllHairColor() {
    const filter: FilterData = {
      sort: [{ name: 'asc' }],
    };

    this.subHairColor = this.hairColorService
      .getAllHairColor(filter)
      .subscribe({
        next: res => {
          if (res.success) {
            this.hairColors = res.data;
            // this.checkHairColorFilter();
          }
        },
        error: err => console.log(err),
      });
  }

  private getAllIntimateHair() {
    const filter: FilterData = {
      sort: [{ name: 'asc' }],
    };

    this.subIntimateHair = this.intimateHairService
      .getAllIntimateHair(filter)
      .subscribe({
        next: res => {
          if (res.success) {
            this.intimateHairs = res.data;
            // this.checkintimateHairFilter();
          }
        },
        error: err => console.log(err),
      });
  }

  private getAllBodyType() {
    const filter: FilterData = {
      sort: [{ name: 'asc' }],
    };

    this.subBodyType = this.bodyTypeService.getAllBodyType(filter).subscribe({
      next: res => {
        if (res.success) {
          this.bodyTypes = res.data;
          // this.checkBodyTypeFilter();
        }
      },
      error: err => console.log(err),
    });
  }

  // TODO: Add better type
  public onSelectBtnDis(
    value: any,
    kind: 'divisions' | 'area' | 'zone',
    event?: MouseEvent,
    name?: string
  ) {
    if (event) event.stopImmediatePropagation();
    this.isSelectedValue = value;
    this.isSelectedValueName = name ? name : toTitleCase(value);
    const newValues = { divisions: null, area: null, zone: null };
    newValues[kind] = this.isSelectedValue;
    this.dataForm?.patchValue(newValues);
    this.menu?.closed.emit();
  }

  public getCategoryName(slug: string) {
    return this.categorys?.find(e => e?.slug === slug)?.name || '';
  }

  // TODO: Add better type
  public onSelectBtnCategory(value: any, event?: MouseEvent) {
    if (event) event.stopImmediatePropagation();
    this.isSelectedValueCategory = value;
    this.dataForm?.patchValue({ category: this.isSelectedValueCategory });
    this.categoryMenu?.closed.emit();
  }

  public getTypeName(slug: string) {
    return this.types?.find(e => e?.slug === slug)?.name || '';
  }

  // TODO: Add better type
  public onSelectBtnType(value: any, event?: MouseEvent) {
    if (event) event.stopImmediatePropagation();
    this.isSelectedValueType = value;
    this.dataForm?.patchValue({ type: this.isSelectedValueType });
    this.typeMenu?.closed.emit();
  }

  public onHideFilter() {
    this.advancedFilter = !this.advancedFilter;
  }

  public formatLabel(value: number): string {
    if (value >= 1000) return Math.round(value / 1000) + 'k';
    return `${value}`;
  }

  public resetFilter() {
    this.dataForm = this.fb.group({
      divisions: [null],
      area: [null],
      zone: [null],
      category: [null],
      type: [null],
      height: this.fb.group({ minHeight: [140], maxHeight: [220] }),
      weight: this.fb.group({ minWeight: [40], maxWeight: [300] }),
      age: this.fb.group({ minAge: [18], maxAge: [80] }),
      bodytype: [null],
      hairColor: [null],
      intimateHairs: [null],
      isGoingOut: [null],
      ownPlace: [null],
      acceptsHandicapped: [null],
      verified: [null],
    });
    this.onSelectBtnCategory(null);
    this.onSelectBtnType(null);
    const formData = this.dataForm.value;
    const queryParams = {
      searchQuery: null,
      categories: formData.category,
      types: formData.type,
      divisions: formData.divisions,
      area: formData.area,
      zone: formData.zone,
      bodyTypes: formData.bodytype,
      hairColors: formData.hairColor,
      intimateHairs: formData.intimateHairs,
      height: null,
      weight: null,
      age: null,
      isGoingOut: null,
      ownPlace: null,
      acceptsHandicapped: null,
      verified: null,
    };
    this.router.navigate(['/ads'], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  public resetSearch() {
    this.searchQuery = null;
    const queryParams = { searchQuery: null };
    this.router.navigate(['/ads'], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.subTypeService.unsubscribe();
    this.subDivisionData.unsubscribe();
    this.subFilterForm.unsubscribe();
    this.subHairColor.unsubscribe();
    this.subIntimateHair.unsubscribe();
    this.subOrientation.unsubscribe();
    this.subBodyType.unsubscribe();
    this.subRouteOne.unsubscribe();
    clearTimeout(this.timeOutOngoing);
    clearTimeout(this.timeOutSubmit);
  }
}
